import mutations from './config-mutations';
import * as actions from './config-actions';

export default {
  namespaced: true,
  state: {
    sys_config: null, // 整个系统配置的对象
    customer_service: {},
    balance_config: {},
    order_review_config: {},
    new_peer_coupon_amount: 0,
    recharge_amount: [],
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/config/config-store.js